import styled from 'styled-components'

const OptionsSection = styled.div`
  margin-top: ${({ theme }) => theme.spacing.medium};
`
export default OptionsSection
